
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/road-trip-wonders",
      function () {
        return require("private-next-pages/blog/road-trip-wonders.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/road-trip-wonders"])
      });
    }
  